module.exports = __webpack_public_path__ + "static/media/xray-training-lateral-flex3.dbf84fb5.png";